import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const pendingUserApi = createApi({
  reducerPath: "pendingUsers",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  tagTypes: ["PendingUsers"],
  endpoints: (builder) => ({
    listPendingUsers: builder.query({
      query: ({ token }) => {
        return apiFunction({ token }, "/api/admin/pending-users/list", "POST");
      },
      providesTags: ["PendingUsers"],
    }),
    approvePendingUser: builder.mutation({
      query: ({ token, id }) => {
        return apiFunction({ token, id }, "/api/admin/pending-users/approve", "POST");
      },
      invalidatesTags: ["PendingUsers"],
    }),
    rejectPendingUser: builder.mutation({
      query: ({ token, id, rejectionReason }) => {
        return apiFunction(
          { token, id, rejectionReason },
          "/api/admin/pending-users/reject",
          "POST"
        );
      },
      invalidatesTags: ["PendingUsers"],
    }),
    // ─── Klinik tarafı (ClinicStaff yöneticisi için) ───────────────
    listClinicPendingUsers: builder.query({
      query: ({ token }) => {
        return apiFunction({ token }, "/api/clinic/pending-users/list", "POST");
      },
      providesTags: ["PendingUsers"],
    }),
    approveClinicPendingUser: builder.mutation({
      query: ({ token, id }) => {
        return apiFunction({ token, id }, "/api/clinic/pending-users/approve", "POST");
      },
      invalidatesTags: ["PendingUsers"],
    }),
    rejectClinicPendingUser: builder.mutation({
      query: ({ token, id, rejectionReason }) => {
        return apiFunction(
          { token, id, rejectionReason },
          "/api/clinic/pending-users/reject",
          "POST"
        );
      },
      invalidatesTags: ["PendingUsers"],
    }),
  }),
});

export const {
  useListPendingUsersQuery,
  useLazyListPendingUsersQuery,
  useApprovePendingUserMutation,
  useRejectPendingUserMutation,
  useListClinicPendingUsersQuery,
  useLazyListClinicPendingUsersQuery,
  useApproveClinicPendingUserMutation,
  useRejectClinicPendingUserMutation,
} = pendingUserApi;
